import {Gauge} from 'lucide-react';
import {modelBrandForName,type ModelBrand} from '@reados/contracts';
import gptIcon from './chat-assets/model-logo-gpt.svg';
import deepseekIcon from './chat-assets/model-logo-deepseek.svg';

/** Copied iPad template artwork; inherit the selected reasoning tint. */
export function ModelGlyph({modelId,brand,size=20}:{modelId?:string;brand?:ModelBrand;size?:number}){
 // Semantic legacy IDs remain a fallback for old catalogs, never user labels.
 const identity=brand??modelBrandForName(modelId),asset=identity==='gpt'?gptIcon:identity==='deepseek'?deepseekIcon:undefined;
 return asset?<span aria-hidden="true" data-model-brand={identity} className="chat-ipad-model-glyph" style={{width:size,height:size,maskImage:`url("${asset}")`,WebkitMaskImage:`url("${asset}")`}}/>:<Gauge size={size} aria-hidden="true" data-model-brand="generic"/>;
}
